import { Box, Button, Typography } from '@astro-ui/components'
import { useHistory } from 'react-router-dom'
import { shallowEqual, useAppSelector } from 'store'

const EmptyState = () => {
  const history = useHistory()

  const formState = useAppSelector((state) => state.outboundSOAddEdit.form, shallowEqual)

  const isFormValid = useAppSelector((state) => {
    const { soType, origin, destination, email, remarks, poReff } = state.outboundSOAddEdit.form

    const isReturnType = soType.toLowerCase() === 'return'

    const isEmailValid = email.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    const isDestinationValid = isReturnType ? !!poReff : !!destination

    return !!soType && !!origin && isDestinationValid && !!remarks && isEmailValid
  }, shallowEqual)

  const handleGoToAddProduct = () => {
    localStorage.setItem('createSOState', JSON.stringify(formState))

    const isSoDirectType = formState.soType.toLowerCase() === 'direct'
    const isSoBadStock = formState.soType.toLowerCase() === 'bad stock'

    if (isSoDirectType || isSoBadStock) {
      history.push('/dashboard/outbound-so/add-product-direct')
      return
    }

    history.push('/dashboard/outbound-so/add-product')
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding="40px"
    >
      <Box display="flex" flexDirection="column" alignItems="center" width="280px">
        <Typography variant="headline-large">Belum ada produk</Typography>
        <Typography textAlign="center" color="#646464">
          Klik ‘Tambah Produk’ untuk menambahkan produk yang akan dikirim ke Hub
        </Typography>
        <Button mt="24px" disabled={!isFormValid} onClick={handleGoToAddProduct}>
          Tambah Produk
        </Button>
      </Box>
    </Box>
  )
}

export default EmptyState
